import { ReactElement, useMemo } from 'react'
import {
    Accordion,
    CardFlip,
    Grid,
    Heading,
    Text,
} from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../redux/hooks'
import { getIsMobile } from '../../redux/reducers/appSettings'

const FooterTemplate = (): ReactElement => {
    const { t } = useTranslation()
    const isMobile = useAppSelector((state) => getIsMobile(state))

    const flippersContent = useMemo(
        () => [
            {
                image: t('cardflip.0.image'),
                textBack: t('cardflip.0.textBack'),
                textFront: t('cardflip.0.textFront'),
            },
            {
                image: t('cardflip.1.image'),
                textBack: t('cardflip.1.textBack'),
                textFront: t('cardflip.1.textFront'),
            },
            {
                image: t('cardflip.2.image'),
                textBack: t('cardflip.2.textBack'),
                textFront: t('cardflip.2.textFront'),
            },
        ],
        [t]
    )

    const flippers = useMemo(
        () => (
            <Grid gap={16}>
                <Heading level={4} css={{ justifySelf: 'center' }}>
                    {t('cardflip.headerText')}:
                </Heading>
                <Grid gap="16" autoFlow={{ '@desktop': 'column' }}>
                    {flippersContent.map((flip, key) => (
                        <CardFlip
                            key={key}
                            image={flip.image}
                            textBack={flip.textBack}
                            textFront={flip.textFront}
                            variant="ImageHeader"
                            height={isMobile ? 150 : 200}
                        />
                    ))}
                </Grid>
            </Grid>
        ),
        [flippersContent, isMobile, t]
    )

    const questions = useMemo(
        () => [
            { title: t('qanda.0.title'), content: t('qanda.0.content') },
            { title: t('qanda.1.title'), content: t('qanda.1.content') },
            { title: t('qanda.2.title'), content: t('qanda.2.content') },
        ],
        [t]
    )

    const accordions = useMemo(
        () => (
            <Grid gap="16">
                <Heading level={4}>{t('qanda.headerText')}</Heading>
                {questions.map((q, key) => (
                    <Accordion
                        key={key}
                        title={q.title}
                        content={
                            <Text css={{ whiteSpace: 'pre-line' }}>
                                {q.content}
                            </Text>
                        }
                    />
                ))}
            </Grid>
        ),
        [questions, t]
    )

    return (
        <Grid gap="32" css={{ py: 64 }}>
            {flippers}
            {accordions}
        </Grid>
    )
}

export default FooterTemplate
